// extracted by mini-css-extract-plugin
module.exports = {"tableIcon":"mutipleLocationsCharts_tableIcon__-eezC","crossIcon":"mutipleLocationsCharts_crossIcon__1ED11"};